// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import pathDetails from './reducer'
export default pathDetails

export {
  getInitialQuickAddValues,
} from './helpers'

export {
  CHANGE_OPEN_PANEL,
  FETCH_PROJECT_ERROR,
  FETCH_PROJECT_SUCCESS,
  FETCHING_PROJECT,
  PROJECT_SUMMARY_MODAL_CLOSE,
  PROJECT_SUMMARY_MODAL_OPEN,
  UPDATE_MODAL_ERROR,
  UPDATE_MODAL_MESSAGE,
} from './types'

export {
  changeOpenPanel,
  clearProjectSummary,
  fetchingProject,
  fetchProjectSuccess,
  fetchProjectError,
  projectSummaryModalClose,
  projectSummaryModalOpen,
  updateCompanies,
  updateHighlightedPaths,
  updateModalError,
  updateModalMessage,
  updateModalPathSet,
  updatePaths,
  updateProjectFilter,
  updateProjectSettings,
  updateProjectSort,
  updateVisiblePathIds,
} from './actions'

export initialState from './initialState'

export {
  addPathToProjectSummary,
  assignProjectFilter,
  assignProjectSort,
  copyPath,
  deleteMultiplePaths,
  fetchAndAddProject,
  fetchAndSetProjectCompanies,
  filterAndSortPathIds,
  getProjectBandOptions,
  getProjectWarnings,
  goToNewProjectSummary,
  handleChangeOpenPanel,
  handlePathsImport,
  quickAddPath,
  removeFilteredPathsFromHighlight,
  removeMultiplePaths,
  removePathFromModalPathSet,
  splitProject,
  toggleAllPathHighlight,
  togglePathHighlight,
  updateMultiplePathsInProjectSummary,
  updatePathInProjectSummary,
  warnUserCannotPerformAction,
} from './thunks'
